import _ from 'lodash';

export default {
  data() {
    return {
      sortnum: '',
      temp: {},

      // proTempData: {
      //   rowCount: 1,
      //   model: "chessSort",
      //   type: "horizontal_1",
      //   icon: "",
      //   iconColor: "#000000",
      //   image: {
      //     percentage: 100,
      //   },
      //   product: {
      //     nameSize: "15",
      //     nameColor: "#000000",
      //     contentSize: "15",
      //     contentColor: "#000000",
      //     showMemberPrice: false,
      //     priceColor: "#dc3545",
      //     memberPriceColor: "#000000"
      //   },
      // }
    };
  },

  methods: {
    saveProductModel() {
      this.$store.dispatch("product/saveWebProductModel", this.proTempData);
    },

    noChange() {
      return _.isEqual(this.proStyle, this.temp);
    },

    toInsertProPage() {
      this.$router.push({
        name: "InsertProduct"
      });
    },

    saveStyle() {
      console.log(this.temp);
      this.$store.commit('productManage/changeProStyle', this.temp);
    },
    
    cancelStyle() {
      this.temp = _.cloneDeep(this.proStyle);
    },
  },

  created() {
    this.temp = _.cloneDeep(this.proStyle);
    this.sortnum = this.temp.proSort;

    this.$store.dispatch("product/getWebProductModel");
  },

  computed: {
    proTempData: {
      get() {
        return this.$store.state.product.webProductModel;
      }
    },
    getRowCount() {
      return () => {
        let rowCount = "col-12";
        switch (this.proTempData.rowCount) {
          case "1":
            rowCount = "col-12";
            break;
          case "2":
            rowCount = "col-6";
            break;
          case "3":
            rowCount = "col-4";
            break;
          case "4":
            rowCount = "col-3";
            break;
        }

        return rowCount;
      }
    },

    proSort: {
      get() {
        return this.$store.state.productManage.proStyle.proSort;
      },
    },
    proStyle: {
      get() {
        return this.$store.state.productManage.proStyle;
      },
    },
  },
};
